import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IMedicationRequest, IDosage } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-medication-request-details',
  templateUrl: './medication-request-details.component.html',
  styleUrls: ['./medication-request-details.component.scss'],
})
export class MedicationRequestDetailsComponent extends AbstractDetailsComponent<IMedicationRequest> {
  @Input() units: string[];
  @Input() periods: string[];
  @Input() days: { text: string, value: string }[];

  @Output() callSave = new EventEmitter<IDosage>();
  @Output() callUpdate = new EventEmitter<IDosage>();

  constructor() { super(); }

}
